// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"399":"f9ab7635","674":"e01418c4","702":"791e4c8b","787":"b950978d"}[chunkId] + ".chunk.css";
};